import React from "react";
import cx from "classnames";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { useMetaMask } from "metamask-react";

import ImgBg from "../../assets/images/vault.svg";
import AppConfig from "../../../../../AppConfig";

import s from "./CodiaxPOAPError.module.scss";

export default function CodiaxPOAPError({ readData }) {
	const meta = useMetaMask();
	const viewPoapsUrl = `${AppConfig.POAP_URL}/${meta.account}`;

	const checkPoaps = () => {
		window.open(viewPoapsUrl, "_blank");
	};

	return (
		<div className={s.root}>
			<p className={s.description}>
				We couldn’t find the POAP needed for access...
			</p>

			<Button
				className={cx(s.button, "btn-default dark")}
				color="primary"
				onClick={checkPoaps}
			>
				Check My POAPs
			</Button>

			<Link to="/">
				<Button
					className={cx(s.button, s.wide, "btn-border dark")}
					color="primary"
					onClick={() => readData()}
				>
					Back to Workshop Home
				</Button>
			</Link>

			<img src={ImgBg} alt="logo" className={s.logo} />
		</div>
	);
}
